import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../components/AuthProvider';

function LoadingSpinner() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: 'var(--color-surface-0)' }}
    >
      <div
        className="animate-spin rounded-full h-10 w-10 border-2 border-transparent"
        style={{
          borderTopColor: 'var(--color-accent)',
          borderBottomColor: 'var(--color-accent)',
        }}
      />
    </div>
  );
}

export function AdminRoute({
  children,
  allowOrganizer = false,
}: {
  children: React.ReactNode;
  allowOrganizer?: boolean;
}) {
  const { loading, canAccessAdminRoutes, isOrganizer } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!canAccessAdminRoutes && !(allowOrganizer && isOrganizer)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function AccessDeniedPage() {
  return (
    <div className="py-20 text-center">
      <h1 className="text-xl font-semibold text-[var(--color-text-primary)]">Access denied</h1>
      <p className="text-[var(--color-text-secondary)] text-sm mt-2">
        You do not have permission to view this page.
      </p>
    </div>
  );
}
